import Annexure1 from "../../assets/pdfs/muhs/Annexure_24-25/Annexure-I.pdf";
import Annexure2 from "../../assets/pdfs/muhs/Annexure_24-25/Annexure-II.pdf";
import Annexure3 from "../../assets/pdfs/muhs/Annexure_24-25/Annexure-III.pdf";
import Annexure4 from "../../assets/pdfs/muhs/Annexure_24-25/Annexure-IV.pdf";
import Annexure5 from "../../assets/pdfs/muhs/Annexure_24-25/Annexure-V.pdf";
import Annexure6 from "../../assets/pdfs/muhs/Annexure_24-25/Annexure-VI.pdf";
import Annexure7 from "../../assets/pdfs/muhs/Annexure_24-25/Annexure-VII.pdf";
import Annexure8 from "../../assets/pdfs/muhs/Annexure_24-25/Annexure-VIII.pdf";
import Annexure9 from "../../assets/pdfs/muhs/Annexure_24-25/Annexure-IX.pdf";
import Annexure10 from "../../assets/pdfs/muhs/Annexure_24-25/Annexure-X.pdf";
import Annexure11 from "../../assets/pdfs/muhs/Annexure_24-25/Annexure-XI.pdf";
import Annexure12 from "../../assets/pdfs/muhs/Annexure_24-25/Annexure-XII.pdf";
import Annexure13 from "../../assets/pdfs/muhs/Annexure_24-25/Annexure-XIII.pdf";
import Annexure14A from "../../assets/pdfs/muhs/Annexure_24-25/Annexure-XIV-(A).pdf";
import Annexure14 from "../../assets/pdfs/muhs/Annexure_24-25/Annexure-XIV.pdf";
import { Box, Stack } from "@mui/material";
import AnnexureTabs from "../../components/muhsComponents/AnnexureTabs";
const annexures = [
  {
    name: "Annexure-I",
    link: Annexure1,
    content: "Seat Matrix",
  },
  {
    name: "Annexure-II",
    link: Annexure2,
    content: "Infrastructure Details",
  },
  {
    name: "Annexure-III",
    link: Annexure3,
    content: "Trust Deed/ By Laws/ Registration Certificate",
  },
  {
    name: "Annexure-IV",
    link: Annexure4,
    content: "Library Details",
  },
  {
    name: "Annexure-V",
    link: Annexure5,
    content: "Clinical Material in Hospital",
  },
  {
    name: "Annexure-VI",
    link: Annexure6,
    content:
      "Details of Equipment and Instruments Required For Physiotherapy Laboratory as per MSR",
  },
  {
    name: "Annexure-VII",
    link: Annexure7,
    content:
      "Total Teaching Staff Information(Approved + Not Approved) as per MSR",
  },
  {
    name: "Annexure-VIII",
    link: Annexure8,
    content: "Total Subject-wise Teacher List (Approved + Not Approved)",
  },
  {
    name: "Annexure-IX",
    link: Annexure9,
    content:
      "Total Non-Teaching Staff & Ancillary Services Information as per MSR",
  },
  {
    name: "Annexure-X",
    link: Annexure10,
    content:
      "Details of Part Time Teachers/ Guest Faculty (Physiotherapy Course)",
  },
  {
    name: "Annexure-XI",
    link: Annexure11,
    content: "Information of Workshops, Activities performed in last one year",
  },
  {
    name: "Annexure-XII",
    link: Annexure12,
    content:
      "Information of Biometric Attendance, Research Articles, student Welfare Schemes",
  },
  {
    name: "Annexure-XIII",
    link: Annexure13,
    content: "AISHE (All India Survey of Higher Education) Certificate",
  },
  {
    name: "Annexure-XIV",
    link: Annexure14,
    content: "Declaration by the Dean/ Princiapl of the College/ Institute",
  },
  {
    name: "Annexure-XIV (A)",
    link: Annexure14A,
    content: "For ONline Transmission of Question Papers",
  },
];

const Muhs2024_25 = () => {
  return (
    <Box
      sx={{
        backgroundColor: "primary.light",
        p: { xs: 1, md: 3 },
        width: "90vw",
      }}
      m={2}
    >
      <Stack
        direction="column"
        alignItems="flex-start"
        justifyContent="center"
        sx={{
          border: "1px solid #e0e0e0",
          p: { xs: 1, md: 3 },
          overflow: "auto",
        }}
      >
        <AnnexureTabs annexures={annexures} />
      </Stack>
    </Box>
  );
};

export default Muhs2024_25;
